import * as React from 'react'

export function ErrorScreenImage() {
  return (
    <svg width={295} height={208} viewBox="0 0 295 208" fill="none">
      <g>
        <path
          d="M61.2683 141.597C45.5625 108.96 72.5067 59.3915 109.521 75.4092C138.517 100.565 164.968 49.097 191.652 74.1104C217.113 95.8224 197.613 119.518 223.633 125.514C264.062 150.876 211.896 192.321 185.162 193.558C147.28 195.311 147.342 194.177 116.042 194.177C104.305 194.177 74.9617 170.052 61.2683 141.597Z"
          fill="#E2F3F7"
        />
        <path
          d="M138.263 63.3127C138.263 63.3127 134.52 80.3266 138.433 83.6248C142.346 86.9234 159.359 87.444 162.082 84.146C164.804 80.847 164.461 64.1892 160.209 60.3657C155.957 56.5423 139.453 60.5349 138.263 63.3127Z"
          fill="#666666"
        />
        <path
          d="M120.147 174.939L117.526 194.502L189.688 194.501L182.581 174.939L120.147 174.939Z"
          fill="#9EC8CF"
        />
        <path
          d="M187.228 155.405C187.228 155.405 167.137 127.661 163.155 122.018C162.303 120.811 177.496 109.042 177.496 109.042C177.496 109.042 201.922 142.754 203.196 147.228C205.972 156.979 187.228 155.405 187.228 155.405Z"
          fill="#B28D76"
        />
        <path
          d="M120.922 93.4245C118.186 97.1241 123.848 155.859 123.848 155.859L179.398 156.212C179.398 156.212 179.312 93.768 178.336 91.8164C177.361 89.8657 123.656 89.7248 120.922 93.4245Z"
          fill="#FF1800"
        />
        <path
          d="M139.448 95.6389C137.498 95.9644 126.766 98.8907 126.766 98.8907C126.766 98.8907 118.311 111.898 117.987 118.726C117.661 125.555 119.949 177.815 119.949 177.815L173.636 183.248L182.575 174.989C182.575 174.989 180.42 122.303 179.769 116.125C179.119 109.947 178.339 101.733 178.339 101.733L160.91 95.6389H139.448Z"
          fill="#476759"
        />
        <path
          d="M126.769 98.8388C126.649 98.6833 115.869 103.006 115.706 103.819C115.543 104.632 100.174 133.205 100.174 133.205L127.265 137.55L135.152 111.827L126.769 98.8388Z"
          fill="#476759"
        />
        <path
          d="M81.1936 194.792H223.489"
          stroke="#345848"
          strokeWidth="0.261561"
          strokeMiterlimit="10"
        />
        <path
          d="M143.338 92.7752C141.08 97.5963 139.1 98.1885 139.454 98.897C139.808 99.6056 146.712 105.281 150.963 104.927C155.213 104.573 160.527 99.6141 160.527 98.197C160.527 96.7799 156.433 90.2267 157.338 84.9148C158.023 80.8996 144.056 83.3206 144.056 83.3206C144.056 83.3206 144.427 90.4503 143.338 92.7752Z"
          fill="#B28D76"
        />
        <path
          d="M127.512 98.7847C127.114 99.62 132.084 121.553 130.113 134.121C128.722 142.995 124.26 151.897 124.26 151.897L127.945 156.882C127.945 156.882 136.008 137.804 136.183 128.701C136.4 117.428 134.015 98.7847 132.714 97.4839C131.414 96.1832 127.91 97.9493 127.512 98.7847Z"
          stroke="#24372B"
          strokeWidth="0.377252"
          strokeMiterlimit="10"
        />
        <path
          d="M119.711 168.177C120.578 168.177 125.928 161.372 127.949 157.555C129.9 153.869 129.9 153.003 129.9 153.003L125.564 149.534C125.564 149.534 118.844 155.604 118.193 156.904C116.833 159.626 118.844 168.177 119.711 168.177Z"
          fill="#24372B"
        />
        <path
          d="M170.769 99.0938C175.192 100.332 182.902 103.315 183.275 104.245C183.583 105.015 197.983 131.952 197.983 131.952L170.161 142.82L170.523 115.415L170.769 99.0938Z"
          fill="#476759"
        />
        <path
          d="M170.285 98.7872C170.414 99.3133 165.713 121.555 167.684 134.123C169.075 142.997 173.537 151.899 173.537 151.899L170.075 156.234C170.075 156.234 161.112 138.779 161.614 128.703C162.175 117.443 163.816 98.8205 165.082 97.4865C166.418 96.0792 170.156 98.261 170.285 98.7872Z"
          stroke="#24372B"
          strokeWidth="0.377252"
          strokeMiterlimit="10"
        />
        <path
          d="M181.872 168.618C180.889 168.741 173.928 162.327 171.132 158.589C168.434 154.981 168.32 154.066 168.32 154.066L172.773 149.793C172.773 149.793 181.191 155.238 182.101 156.517C184.003 159.193 182.855 168.495 181.872 168.618Z"
          fill="#24372B"
        />
        <path
          d="M139.448 98.8907C139.803 99.5986 146.707 105.275 150.957 104.921C155.208 104.567 160.521 99.6077 160.521 98.1907C160.521 97.7848 160.259 96.854 159.886 95.6389H141.737C140.237 97.8893 139.182 98.358 139.448 98.8907Z"
          fill="#A2816E"
        />
        <path
          d="M139.259 70.4708C139.259 73.1638 140.855 81.1484 142.467 84.2904C144.08 87.4317 148.2 89.0768 151.065 88.9278C153.932 88.7781 159.127 85.3375 159.664 83.2433C160.202 81.1484 161.865 72.0925 161.865 69.8486C161.865 67.6047 162.723 64.3974 160.995 62.7934C159.383 61.2979 153.322 61.4679 149.561 61.6175C145.799 61.7672 141.959 61.0803 140.346 63.6235C138.805 66.0543 139.259 70.4708 139.259 70.4708Z"
          fill="#B28D76"
        />
        <path
          d="M139.789 67.2993C139.24 68.049 139.268 69.6073 139.969 70.5603C140.67 71.5132 141.906 72.6538 142.974 73.0303C144.043 73.4055 145.796 73.7055 146.885 73.2381C149.263 72.2178 150.455 68.2772 149.8 67.5399C148.878 66.5032 147.278 66.015 145.09 66.0209C142.902 66.0267 140.874 65.8202 139.789 67.2993Z"
          fill="#24372B"
        />
        <path
          d="M161.267 67.2993C161.816 68.049 161.787 69.6073 161.087 70.5603C160.385 71.5132 159.15 72.6538 158.082 73.0303C157.013 73.4055 155.26 73.7055 154.171 73.2381C151.793 72.2178 150.601 68.2772 151.256 67.5399C152.178 66.5032 153.778 66.015 155.966 66.0209C158.154 66.0267 160.182 65.8202 161.267 67.2993Z"
          fill="#24372B"
        />
        <path
          d="M146.344 66.964L153.76 67.0509"
          stroke="#345848"
          strokeWidth="0.392342"
          strokeMiterlimit="10"
        />
        <path
          d="M135.948 85.3135C135.948 85.3135 138.963 86.1089 140.051 84.6527C139.809 82.1049 137.936 64.6662 140.233 63.4525C142.529 62.2393 160.538 61.7543 161.867 63.9381C163.196 66.1218 160.638 84.3932 161.026 84.7076C161.732 85.2808 163.152 85.3716 164.24 84.037C165.327 82.7023 168.033 70.0004 166.582 64.4192C165.568 60.5164 160.57 51.6749 150.497 51.5069C141.674 51.3592 136.259 56.5306 134.711 63.076C133.019 70.2351 134.739 82.28 135.948 85.3135Z"
          fill="#DBDACF"
        />
        <path
          d="M145.027 52.1092L145.637 61.8853L147.954 62.1748C147.954 62.1748 147.868 52.3332 147.54 51.7564C147.457 51.6123 145.725 51.8456 145.027 52.1092Z"
          fill="white"
        />
        <path
          d="M154.591 51.9703L154.258 62.143L151.758 62.0892C151.758 62.0892 151.773 52.2167 152.095 51.6504C152.174 51.5085 153.896 51.7199 154.591 51.9703Z"
          fill="white"
        />
        <path
          d="M139.292 85.2586C139.292 85.2586 136.639 69.1259 137.418 65.7676C138.198 62.4093 139.072 61.7805 141.687 61.0876C144.302 60.3948 157.763 59.5699 161.704 62.2419C163.645 63.5564 163.055 70.1024 162.874 73.3234C162.678 76.7654 161.838 84.886 161.838 84.886C161.838 84.886 160.812 84.9357 160.621 84.3193C160.426 83.6899 162.291 66.9964 161.315 64.7603C160.338 62.5243 152.114 62.6675 150.101 62.6675C148.148 62.6675 142.529 63.1041 141.515 63.561C140.564 63.9891 139.179 63.7695 139.179 68.1474C139.179 72.4293 140.175 84.8265 140.175 84.8265L139.292 85.2586Z"
          fill="#C7C6B6"
        />
        <path
          d="M140.854 96.9344C140.854 96.9344 101.245 130.204 100.475 132.484C99.2669 136.058 104.403 148.675 105.294 149.947C106.184 151.219 111.543 151.528 112.888 151.129C114.233 150.729 117.1 147.978 119.843 144.608C135.059 125.915 147.448 105.194 147.448 105.194L140.854 96.9344Z"
          fill="#C19F88"
        />
        <path
          d="M170.841 125.178L203.415 148.907C203.415 148.907 200.859 163.753 199.969 165.024C199.078 166.296 193.719 166.605 192.374 166.206C191.03 165.806 188.934 163.71 185.95 160.55C174.659 148.592 163.731 131.854 163.731 131.854L170.841 125.178Z"
          fill="#BA977C"
        />
        <path
          d="M168.069 116.117C168.069 116.117 169.603 119.183 169.838 120.245C170.074 121.306 169.525 122.501 169.484 123.429C167.833 120.48 167.244 119.537 167.244 119.537L168.069 116.117Z"
          fill="#B28D76"
        />
        <path
          d="M165.894 116.131L170.841 125.157L163.73 131.834C163.73 131.834 154.618 127.862 153.82 126.016C153.154 124.477 158.936 116.232 158.936 116.232C158.936 116.232 164.06 114.469 165.894 116.131Z"
          fill="#BA977C"
        />
        <path
          d="M153.863 186.241L154.95 194.719"
          stroke="#D2EDF3"
          strokeWidth="0.251501"
          strokeMiterlimit="10"
        />
        <path
          d="M124.298 183.051C124.298 183.051 149.733 186.047 152.119 186.311C156.032 186.746 174.072 188.268 174.072 188.268L181.679 182.182"
          stroke="#D2EDF3"
          strokeWidth="0.251501"
          strokeMiterlimit="10"
        />
        <path
          d="M173.203 125.526L163.409 133.491L167.263 138.145C167.263 138.145 176.849 129.539 176.747 129.071C176.645 128.604 173.203 125.526 173.203 125.526Z"
          fill="#E6E6D5"
        />
        <path
          d="M169.408 126.262C168.207 126.672 167.135 127.293 166.648 128.105C166.161 128.919 165.479 130.683 165.885 132.142C166.321 133.71 167.955 135.59 169.235 135.897C170.515 136.204 172.55 135.782 173.294 135.072C174.037 134.361 174.767 133.502 175.001 132.287C175.239 131.053 175.36 129.975 174.2 128.141C173.273 126.675 171.322 126.252 170.768 126.222C170.213 126.191 169.408 126.262 169.408 126.262Z"
          stroke="white"
          strokeWidth="0.140841"
          strokeMiterlimit="10"
        />
        <path
          d="M172.272 127.456C171.304 127.052 170.311 126.853 169.592 127.099C168.874 127.344 167.55 128.085 167.071 129.234C166.556 130.469 166.643 132.564 167.299 133.467C167.955 134.369 169.457 135.227 170.287 135.187C171.117 135.149 172.013 135.008 172.774 134.367C173.548 133.717 174.169 133.1 174.36 131.296C174.513 129.855 173.489 128.509 173.154 128.182C172.818 127.856 172.272 127.456 172.272 127.456Z"
          fill="white"
        />
        <path
          d="M170.963 127.855L171.252 130.608L167.92 133.361"
          stroke="#2D656F"
          strokeWidth="0.135811"
          strokeMiterlimit="10"
        />
        <path
          d="M144.117 86.2351C144.117 86.2351 140.991 94.0531 140.738 96.7107C140.485 99.3683 146.215 106.434 147.23 105.687C149.693 103.876 155.161 98.3801 155.49 96.7035C156.214 93.0079 152.664 88.8058 152.664 88.8058C152.664 88.8058 156.322 87.0371 157.084 86.2698C158.038 85.3089 158.171 83.5167 157.518 83.2271C156.867 82.9376 149.147 85.1926 147.888 86.0573C146.627 86.9221 145.801 87.9339 145.801 87.9339L144.117 86.2351Z"
          fill="#C19F88"
        />
        <path
          d="M112.258 44.1656C110.597 45.3912 111.775 48.5619 113.431 49.1547C115.386 49.8554 118.709 49.6802 118.417 47.054C118.123 44.4284 113.92 42.9401 112.258 44.1656Z"
          stroke="#C7C6B6"
          strokeWidth="0.377252"
          strokeMiterlimit="10"
        />
        <path
          d="M121.971 57.0917C121.971 59.1539 125.088 59.9906 126.61 59.3382C128.132 58.6859 128.204 55.9322 126.972 55.1348C125.25 54.0204 121.971 54.7001 121.971 57.0917Z"
          stroke="#C7C6B6"
          strokeWidth="0.377252"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  )
}
